import { styled } from "@mui/material/styles";
import { Box } from "@mui/system";

const AppContainerWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
}));

export default AppContainerWrapper;
